class VideoPlayer extends HTMLElement {
    connectedCallback() {
        this.videoPlayer = this.querySelector('.artikelvideo');
        if (this.scrollArea === undefined) this.videoSourceLaden();
        this.initSichtbarkeitObserver();
    }

    initSichtbarkeitObserver() {
        this.rootElement = this.closest(this.scrollArea);
        this.options = {
            root: this.rootElement,
            threshold: [0.95, 0.96, 0.97, 0.98, 0.99, 1.0]
        };
        this.observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                this.sichtbarkeitHandler(entry);
            }
        }, this.options);
        this.observer.observe(this.videoPlayer);
    }

    sichtbarkeitHandler(entry) {
        if (entry.intersectionRatio === 1 && this.source !== undefined) {
            this.videoSourceLaden();
        }
        if (entry.intersectionRatio < 1) {
            this.videoPausieren();
        }
    }

    videoSourceLaden() {
        this.videoPlayer.src = this.source;
        this.removeAttribute('data-src');
    }

    videoPausieren() {
        this.videoPlayer.pause();
    }

    get source() {
        return this.dataset['src'];
    }

    get scrollArea() {
        return this.dataset['scrollArea'];
    }
}

if (!customElements.get("video-player")) {
    customElements.define("video-player", VideoPlayer);
}
